import React from "react"
import {
  View,
  Text,
  Window,
  Input,
  Button,
  Touchable,
} from "react-ame-components"

export class LoginExample extends React.Component {
  state = {
    inputLogin: "",
  }
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <View
            width="780px"
            backgroundColor="neutral-100"
            padding="big"
            borderRadius="small"
            shadow="level-2"
            direction="column"
            dataCy="teste-modelo">
            <Text
              fontSize="large"
              lineHeight="large"
              fontWeight="bold"
              color="neutral-700">
              Ame Sua Conta [color=primary]:)[/color]
            </Text>
            <Text
              fontSize="small"
              lineHeight="large"
              color="neutral-700">
              Venda com Ame e controle tudo pelo celular.
            </Text>
            <View paddingTop="big">
              <Input
                placeholder="Digite seu login"
                onChange={e => {
                  this.setState({ inputLogin: e })
                }}
                value={this.state.inputLogin}
                type="text"
              />
            </View>
            <View
              paddingTop="big"
              paddingBottom="big">
              <Input
                placeholder="Digite sua senha"
                type="password"
              />
            </View>
            <View
              width="100%"
              justify="center">
              <View width="auto">
                <Touchable>
                  <Text
                    textAlign="center"
                    fontSize="extra-small"
                    lineHeight="large">
                    Esqueceu a senha?
                  </Text>
                </Touchable>
              </View>
            </View>
            <View height="80px" />
            <View
              justify="center"
              direction="column"
              align="center">
              <View
                width="335px"
                marginBottom="small">
                <Button
                  text="Entrar"
                  label="Entrar"
                  onClick={() => console.log("Entrar")}
                />
              </View>
            </View>
          </View>
          <View
            paddingTop="big"
            paddingBottom="big"
            direction="row"
            justify="around"
            align="center">
            <View
              width="90%"
              height="1px"
              backgroundColor="neutral"
            />
            <View
              marginLeft="medium"
              marginRight="medium"
              width="auto">
              <Text
                fontSize="small"
                lineHeight="large"
                color="neutral-500">
                Ou
              </Text>
            </View>
            <View
              width="90%"
              height="1px"
              backgroundColor="neutral"
            />
          </View>
          <View
            direction="column"
            align="center"
            justify="center">
            <Text
              fontSize="small"
              lineHeight="large"
              color="neutral-700">
              Ainda não tem conta?
            </Text>
            <View width="335px">
              <Button
                type="secondary"
                text="Criar Conta"
                label="Criar Conta"
                onClick={() => console.log("Criar conta")}
              />
            </View>
          </View>
        </View>
      </Window>
    )
  }
}
